import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

import { BinsSettingsView } from "./BinsSettingsView";

type Props = {
  viewTitle: ViewNameTranslation;
};

export function BinsSettingsPage({ viewTitle }: Props) {
  useNavbar({ viewTitle });
  return <BinsSettingsView />;
}
